type TFetchError = { response?: Response & { _data: any } }

type TErrorHandlers = {
  handleUnknownError: (err: unknown) => void
  handle400Error?: (err: TFetchError) => void
  handle401Error?: (err: TFetchError) => void
  handle403Error?: (err: TFetchError) => void
  handle404Error?: (err: TFetchError) => void
  handle429Error?: (err: TFetchError) => void
  handle500OrAboveError?: (err: TFetchError) => void
}

// Function implementation repeated for completeness
export function extractFirstError(payload: any): string {
  const extractFromErrorDetail = (text: string): string | null => {
    const match = text.match(/string='([^']*)'/)
    return match ? match[1] : null
  }

  const findFirstError = (obj: any): string | null => {
    if (typeof obj === 'string') {
      if (obj.includes('ErrorDetail')) {
        const errorMessage = extractFromErrorDetail(obj)
        if (errorMessage) return errorMessage
      }
      return null
    }

    if (obj && typeof obj === 'object') {
      for (const value of Object.values(obj)) {
        const error = findFirstError(value)
        if (error) return error
      }
    }

    return null
  }

  const errorMessage = findFirstError(payload)
  return errorMessage || 'Invalid Inputs'
}

export function handleFetchError(error: unknown, handlers: TErrorHandlers) {
  // Handle non FetchErrors
  if (
    typeof error === 'string' ||
    !error ||
    !Object.prototype.hasOwnProperty.call(error, 'response')
  ) {
    handlers.handleUnknownError(error)
    return
  }

  // Cast error to FetchError
  const castedError = error as TFetchError
  const responseStatus = castedError.response?.status || 500
  if (responseStatus >= 500 && handlers.handle500OrAboveError) {
    handlers.handle500OrAboveError(castedError)
  } else if (responseStatus === 404 && handlers.handle404Error) {
    handlers.handle404Error(castedError)
  } else if (responseStatus === 403 && handlers.handle403Error) {
    handlers.handle403Error(castedError)
  } else if (responseStatus === 401 && handlers.handle401Error) {
    handlers.handle401Error(castedError)
  } else if (responseStatus === 400 && handlers.handle400Error) {
    console.log('400 error', castedError)
    handlers.handle400Error(castedError)
  } else if (responseStatus === 429 && handlers.handle429Error) {
    handlers.handle429Error(castedError)
  }
}

function extractErrorString(errorDetail: string) {
  // Use a regular expression to match the string inside single quotes
  const match = errorDetail.match(/'(.*?)'/)

  // If a match is found, return the captured group (the content inside quotes)
  // Otherwise, return null or an empty string, depending on your preference
  return match ? match[1] : null
}

export function getErrorDetails(error: TFetchError) {
  // Example usage:
  return extractErrorString(error.response?._data.detail)
}
